/**
 * @Author: zachalam
 * @Date:   2017-01-04T13:20:10-08:00
 * @Last modified by:   Daniel
 * @Last modified time: 2017-04-12T16:35:07-07:00
 */

import React, { Component } from "react";
import Loader from 'react-loading-overlay';
import { isEmpty } from "lodash";
import SearchResultsFilters from "./SearchResultsFilters";
import SearchResultsTopBar from "./SearchResultsTopBar";
import UserCard from "../../common/UserCard";
import glamorous from "glamorous";
import { css } from 'glamor'
import { color, borders } from "../../../style/index";
import ButtonRound from "../../blocks/ButtonRound";
import Button from '../../blocks/Button';
import TripCard from "../../common/TripCard";
import LoadMore from "../../common/LoadMore";
import { connectScreenSize } from 'react-screen-size';
import NoResults from "./NoResults";
import Select from '../../common/Select';
import ScrollToTop from "../../common/ScrollToTop";

const SearchResultsPage = glamorous.div({
});

const FilterTopBar = glamorous.div({
  display: 'flex',
  justifyContent: 'space-between'
});

const SortBy = glamorous.div({
  fontSize: 16,
  padding: '10px 16px'
});

const SearchFooterPad = glamorous.div({
  display: 'inline-block',
  height: '40'
});

const SearchPage = glamorous.div({
  backgroundColor: color.BRAND_1_DARK,
  color: "#fff",
  paddingTop: "1.5em"
});

const MainContent = glamorous.div({
  display: 'flex',
  maxWidth: '1070px',
  margin: '0 auto',
  "@media(max-width: 800px)": {
    position: 'relative',
    height: 'auto'
  }
});

const UserGrid = glamorous.div({
  display: "grid",
  gridTemplateColumns: "repeat(3, 230px)",
  gridGap: "24px 32px",
  justifyContent: "center",
  "@media(max-width: 800px)": {
    gridTemplateColumns: "repeat(1, 1fr)",
    justifyItems: "center"
  }
});

const TripGrid = glamorous.div({
  display: "grid",
  gridTemplateColumns: "repeat(2, 319px)",
  justifyContent: "center",
  gridGap: "26px 42px",
  "@media(max-width: 800px)": {
    gridTemplateColumns: "repeat(1, 1fr)",
    justifyItems: "center"
  }
});

const SearchResultsList = glamorous.div({
  width: '100%',
  paddingBottom: 40
  },
  (({filterIsToggled}) => ({
    // Hide search result list when filter is toggled and
    // in mobile view (filter should only be visible)
    "@media(max-width: 800px)": {
      display: filterIsToggled && "none"
    }
  }))
);


class SearchResults extends Component {
  state = {
    filterIsToggled: false,
    order: this.props.search.filters.order
  }

  renderUserCards = () => {
    const profiles = this.props.search.profile;

    if(isEmpty(profiles) && !this.props.search.isFetching) {
      return <NoResults isMembers={true} profiles={this.props.search.search_people_near_me} />;
    }    

    if(!isEmpty(profiles)) {
      const cards = Object.keys(profiles).map(key => {
        const profile = profiles[key];
        return (
          <UserCard
            member={profile}
            isFavorite={profile.isFavorite}
            favToggle={this.props.favToggle}
            favKey={key}
            key={key}
          />
        );
      });
      return <UserGrid> {cards} </UserGrid>
    }
  };

  renderTripCards = () => {
    const trips = this.props.search.trip;

    if(isEmpty(trips) && !this.props.search.isFetching) {
      return <NoResults isMembers={false} profiles={this.props.search.search_people_near_me} />;
    }        

    if(!isEmpty(trips)) {
      const cards = Object.keys(trips).map(key => {
        const trip = trips[key];

        return (
          <TripCard
            trip={trip}
            username={trip.account.data.username}
            profile={trip.account.data.profile.data}
            isLiked={trip.is_liked}
            joinTrip={this.props.joinTrip}
            index={key}
            key={key}
          />
        )
      });

      return <TripGrid> { cards } </TripGrid>;
    }
  }

  runSearch = (saveFilters=false) => {
    if(saveFilters) {
      const newFilters = Object.assign({}, this.props.search.filters, {order: this.state.order});

      this.props.saveFilters({formData: newFilters, filterMembersLivingIn: this.props.search.filterMembersLivingIn })
    }

    if(this.props.search.filterMembersLivingIn)
      this.props.refreshProfile();
    else {
      const {
        latitude,
        longitude
      } = this.props.search.filters;

      this.props.getTripDestinationPhoto(latitude, longitude);
      this.props.refreshTrips();
    }
  }

  componentWillMount() {
    this.runSearch();
  }

  onChangeHandler = (e) => {
    this.setState({[e.target.id]: e.target.value}, () => {
      this.runSearch(true);
    });
  }

  filterClickHandler = () => {
    this.setState({filterIsToggled: !this.state.filterIsToggled});
  }

  renderFilters = () => {
    const {
      search,
      resetIndividualFilter
    } = this.props;

    const memberSearch = search.filterMembersLivingIn;
    let shouldShowFilters = false;

    if((this.props.small || this.props.mobile) && this.state.filterIsToggled) {
      shouldShowFilters = true
    }
    if(!(this.props.small || this.props.mobile)) {
      shouldShowFilters = true
    }

    if(shouldShowFilters) {
      return (
        <SearchResultsFilters
          filters={search.filters}
          defaultFilters={search.defaultFilters}
          resetIndividualFilter={resetIndividualFilter}
          memberSearch={memberSearch}
          refreshProfile={this.props.refreshProfile}
          refreshTrips={this.props.refreshTrips}
          saveFilters={this.props.saveFilters}
          toggleFilters={this.toggleFilters}
          filterClickHandler={this.filterClickHandler}
        />
      )
    } else {
      return null
    }
  }

  filterButton = () => {
    let filterColor = '#FFF';

    return (
      <Button onClick={this.filterClickHandler} extraStyles={{color: filterColor}}>
        <svg width='22' height='22' viewBox='0 0 24 24' fill={filterColor}>
          <g id="Filters">
              <path d="M3.66666667,7.33333333 C1.65,7.33333333 0,5.68333333 0,3.66666667 C0,1.65 1.65,0 3.66666667,0 C5.68333333,0 7.33333333,1.65 7.33333333,3.66666667 C7.33333333,5.68333333 5.68333333,7.33333333 3.66666667,7.33333333 L3.66666667,7.33333333 Z M3.66666667,1.83333333 C2.65833333,1.83333333 1.83333333,2.65833333 1.83333333,3.66666667 C1.83333333,4.675 2.65833333,5.5 3.66666667,5.5 C4.675,5.5 5.5,4.675 5.5,3.66666667 C5.5,2.65833333 4.675,1.83333333 3.66666667,1.83333333 L3.66666667,1.83333333 Z" id="Shape"></path>
              <path d="M14.6666667,14.6666667 C12.65,14.6666667 11,13.0166667 11,11 C11,8.98333333 12.65,7.33333333 14.6666667,7.33333333 C16.6833333,7.33333333 18.3333333,8.98333333 18.3333333,11 C18.3333333,13.0166667 16.6833333,14.6666667 14.6666667,14.6666667 L14.6666667,14.6666667 Z M14.6666667,9.16666667 C13.6583333,9.16666667 12.8333333,9.99166667 12.8333333,11 C12.8333333,12.0083333 13.6583333,12.8333333 14.6666667,12.8333333 C15.675,12.8333333 16.5,12.0083333 16.5,11 C16.5,9.99166667 15.675,9.16666667 14.6666667,9.16666667 L14.6666667,9.16666667 Z" id="Shape"></path>
              <path d="M21.0833333,4.58333333 L6.41666667,4.58333333 C5.86666667,4.58333333 5.5,4.21666667 5.5,3.66666667 C5.5,3.11666667 5.86666667,2.75 6.41666667,2.75 L21.0833333,2.75 C21.6333333,2.75 22,3.11666667 22,3.66666667 C22,4.21666667 21.6333333,4.58333333 21.0833333,4.58333333 L21.0833333,4.58333333 Z" id="Shape"></path>
              <path d="M21.0833333,11.9166667 L17.4166667,11.9166667 C16.8666667,11.9166667 16.5,11.55 16.5,11 C16.5,10.45 16.8666667,10.0833333 17.4166667,10.0833333 L21.0833333,10.0833333 C21.6333333,10.0833333 22,10.45 22,11 C22,11.55 21.6333333,11.9166667 21.0833333,11.9166667 L21.0833333,11.9166667 Z" id="Shape"></path>
              <path d="M11.9166667,11.9166667 L0.916666667,11.9166667 C0.366666667,11.9166667 0,11.55 0,11 C0,10.45 0.366666667,10.0833333 0.916666667,10.0833333 L11.9166667,10.0833333 C12.4666667,10.0833333 12.8333333,10.45 12.8333333,11 C12.8333333,11.55 12.4666667,11.9166667 11.9166667,11.9166667 L11.9166667,11.9166667 Z" id="Shape"></path>
              <path d="M9.16666667,22 C7.15,22 5.5,20.35 5.5,18.3333333 C5.5,16.3166667 7.15,14.6666667 9.16666667,14.6666667 C11.1833333,14.6666667 12.8333333,16.3166667 12.8333333,18.3333333 C12.8333333,20.35 11.1833333,22 9.16666667,22 L9.16666667,22 Z M9.16666667,16.5 C8.15833333,16.5 7.33333333,17.325 7.33333333,18.3333333 C7.33333333,19.3416667 8.15833333,20.1666667 9.16666667,20.1666667 C10.175,20.1666667 11,19.3416667 11,18.3333333 C11,17.325 10.175,16.5 9.16666667,16.5 L9.16666667,16.5 Z" id="Shape"></path>
              <path d="M21.0833333,19.25 L11.9166667,19.25 C11.3666667,19.25 11,18.8833333 11,18.3333333 C11,17.7833333 11.3666667,17.4166667 11.9166667,17.4166667 L21.0833333,17.4166667 C21.6333333,17.4166667 22,17.7833333 22,18.3333333 C22,18.8833333 21.6333333,19.25 21.0833333,19.25 L21.0833333,19.25 Z" id="Shape"></path>
              <path d="M6.41666667,19.25 L0.916666667,19.25 C0.366666667,19.25 0,18.8833333 0,18.3333333 C0,17.7833333 0.366666667,17.4166667 0.916666667,17.4166667 L6.41666667,17.4166667 C6.96666667,17.4166667 7.33333333,17.7833333 7.33333333,18.3333333 C7.33333333,18.8833333 6.96666667,19.25 6.41666667,19.25 L6.41666667,19.25 Z" id="Shape"></path>
          </g>
        </svg>
        &nbsp; Filters
      </Button>
    );
  }

  renderFilterTopBar = () => {
    if(this.props.small || this.props.mobile) {
      return (
        <FilterTopBar>
          { this.filterButton() }
          <SortBy> Sort By: &nbsp; 
            <Select onChange={this.onChangeHandler} value={this.state.order} id="order"
            arrow="light" dropdownStyle="mt-purple" dropdownStyleOptions={{width:'164', fontSize:'16'}}>
              <option value="recent">Recently Logged In</option>
              <option value="newest">Newest Member</option>
              <option value="oldest">Oldest Member</option>
              <option value="distance">Nearest Distance</option>
            </Select>
          </SortBy>
        </FilterTopBar>
      );
    } else {
      return null
    }
  }

  scrollToTop = () => {
    if (!this.props.search.isFetching) {
      return <ScrollToTop {...css({position: "absolute", bottom: 10, right: 10})}/>
    }
  }

  render() {
    const {
      search,
      resetIndividualFilter
    } = this.props;

    const memberSearch = search.filterMembersLivingIn;
    
    return (
      <SearchResultsPage>
        <SearchResultsTopBar
          saveFilters={this.props.saveFilters}
          search={this.props.search}
          refreshTrips={this.props.refreshTrips}
          refreshProfile={this.props.refreshProfile}
        />
        <SearchPage>
          { this.renderFilterTopBar() }
          <MainContent>
            { this.renderFilters() }
            <SearchResultsList filterIsToggled={this.state.filterIsToggled}>
              {memberSearch ? this.renderUserCards() : this.renderTripCards()}
              <Loader active={this.props.search.isFetching} spinner text={'loading...'} color={color.BRAND_1} background={color.BRAND_1_DARK} zindex={999}>
                {this.props.moreExists &&
                  <LoadMore
                    dropInSearchResults={this.props.loadMore}
                    searchUsers={memberSearch}
                    filters={this.props.search.filters}
                  />
                }
              </Loader>
              <SearchFooterPad/> 
            </SearchResultsList>
          </MainContent>
          {this.scrollToTop()}
        </SearchPage>
      </SearchResultsPage>
    );
  }
}

const mapScreenToProps = screenSize => {
  return screenSize;
}

export default connectScreenSize(mapScreenToProps)(SearchResults);



// WEBPACK FOOTER //
// ./src/components/pages/Search/SearchResults.jsx